export const ENTITY_TYPES = {
  AssetType: 'AssetType',
  AuthResponse: 'AuthResponse',
  AuthUserWithCredentialsResponse: 'AuthUserWithCredentialsResponse',
  AuthUserWithToken: 'AuthUserWithToken',
  BusinessActivitiesResponse: 'BusinessActivitiesResponse',
  BusinessActivitiesTreeUpdateInput: 'BusinessActivitiesTreeUpdateInput',
  BusinessActivity: 'BusinessActivity',
  BusinessActivityCreateInput: 'BusinessActivityCreateInput',
  BusinessActivityFilterInput: 'BusinessActivityFilterInput',
  BusinessActivityUpdateInput: 'BusinessActivityUpdateInput',
  BusinessDayInput: 'BusinessDayInput',
  BusinessProcess: 'BusinessProcess',
  BusinessProcessCreateInput: 'BusinessProcessCreateInput',
  BusinessProcessFilterInput: 'BusinessProcessFilterInput',
  BusinessProcessUpdateInput: 'BusinessProcessUpdateInput',
  BusinessProcessesResponse: 'BusinessProcessesResponse',
  BusinessProcessesTreeUpdateInput: 'BusinessProcessesTreeUpdateInput',
  BusinessUnit: 'BusinessUnit',
  BusinessUnitCreateInput: 'BusinessUnitCreateInput',
  BusinessUnitFilterInput: 'BusinessUnitFilterInput',
  BusinessUnitUpdateInput: 'BusinessUnitUpdateInput',
  BusinessUnitsResponse: 'BusinessUnitsResponse',
  BusinessUnitsTreeUpdateInput: 'BusinessUnitsTreeUpdateInput',
  CacheControlScope: 'CacheControlScope',
  CompaniesResponse: 'CompaniesResponse',
  Company: 'Company',
  CompanyCreateInput: 'CompanyCreateInput',
  CompanyField: 'CompanyField',
  CompanyFieldFilterInput: 'CompanyFieldFilterInput',
  CompanyFieldsResponse: 'CompanyFieldsResponse',
  CompanyFilterInput: 'CompanyFilterInput',
  CompanyUpdateInput: 'CompanyUpdateInput',
  DateString: 'DateString',
  DeleteResponse: 'DeleteResponse',
  EmploymentStatus: 'EmploymentStatus',
  FileInput: 'FileInput',
  Filter: 'Filter',
  FilterFilterInput: 'FilterFilterInput',
  FiltersResponse: 'FiltersResponse',
  Float: 'Float',
  GenerateUploadUrlsResponse: 'GenerateUploadUrlsResponse',
  ID: 'ID',
  IResponse: 'IResponse',
  Int: 'Int',
  JSON: 'JSON',
  LOG_ACTION_TYPES: 'LOG_ACTION_TYPES',
  LOG_ENTITY_TYPES: 'LOG_ENTITY_TYPES',
  LicenceInput: 'LicenceInput',
  Log: 'Log',
  Mutation: 'Mutation',
  MutationResponse: 'MutationResponse',
  OrderDirection: 'OrderDirection',
  OrderInput: 'OrderInput',
  Pagination: 'Pagination',
  PaginationInput: 'PaginationInput',
  Plan: 'Plan',
  PlanAction: 'PlanAction',
  PlanActionCreateInput: 'PlanActionCreateInput',
  PlanActionFilterInput: 'PlanActionFilterInput',
  PlanActionUpdateInput: 'PlanActionUpdateInput',
  PlanActionUpdateResponse: 'PlanActionUpdateResponse',
  PlanActionsResponse: 'PlanActionsResponse',
  PlanCreateInput: 'PlanCreateInput',
  PlanCreateResponse: 'PlanCreateResponse',
  PlanDeleteInput: 'PlanDeleteInput',
  PlanFilterInput: 'PlanFilterInput',
  PlanKPI: 'PlanKPI',
  PlanObjective: 'PlanObjective',
  PlanObjectiveComment: 'PlanObjectiveComment',
  PlanObjectiveCommentCreateInput: 'PlanObjectiveCommentCreateInput',
  PlanObjectiveCreateInput: 'PlanObjectiveCreateInput',
  PlanObjectiveFilterInput: 'PlanObjectiveFilterInput',
  PlanObjectiveResource: 'PlanObjectiveResource',
  PlanObjectiveResourceCreateInput: 'PlanObjectiveResourceCreateInput',
  PlanObjectiveUpdateInput: 'PlanObjectiveUpdateInput',
  PlanObjectiveUpdateResponse: 'PlanObjectiveUpdateResponse',
  PlanObjectivesResponse: 'PlanObjectivesResponse',
  PlanTheme: 'PlanTheme',
  PlanThemeInput: 'PlanThemeInput',
  PlanType: 'PlanType',
  PlanTypeCreateInput: 'PlanTypeCreateInput',
  PlanTypeFilterInput: 'PlanTypeFilterInput',
  PlanTypeLevel: 'PlanTypeLevel',
  PlanTypeLevelInput: 'PlanTypeLevelInput',
  PlanTypeUpdateInput: 'PlanTypeUpdateInput',
  PlanTypesResponse: 'PlanTypesResponse',
  PlanUpdateInput: 'PlanUpdateInput',
  PlanUpdateTreeActionInput: 'PlanUpdateTreeActionInput',
  PlanUpdateTreeInput: 'PlanUpdateTreeInput',
  PlanUpdateTreeObjectiveInput: 'PlanUpdateTreeObjectiveInput',
  PlanValue: 'PlanValue',
  PlanValueInput: 'PlanValueInput',
  PlansResponse: 'PlansResponse',
  Position: 'Position',
  PositionCreateInput: 'PositionCreateInput',
  PositionFilterInput: 'PositionFilterInput',
  PositionUpdateInput: 'PositionUpdateInput',
  PositionsResponse: 'PositionsResponse',
  PositionsTreeUpdateInput: 'PositionsTreeUpdateInput',
  Query: 'Query',
  Upload: 'Upload',
  User: 'User',
  UserCreateInput: 'UserCreateInput',
  UserFilter: 'UserFilter',
  UserGender: 'UserGender',
  UserResponse: 'UserResponse',
  UserRoles: 'UserRoles',
  UserStatus: 'UserStatus',
  UserUpdateInput: 'UserUpdateInput',
  UsersResponse: 'UsersResponse',
  __Directive: '__Directive',
  __DirectiveLocation: '__DirectiveLocation',
  __EnumValue: '__EnumValue',
  __Field: '__Field',
  __InputValue: '__InputValue',
  __Schema: '__Schema',
  __Type: '__Type',
  __TypeKind: '__TypeKind'
}

